export default __webpack_public_path__ + "static/media/bg9.23f0cc3d.png";